import { ProposalsRequest } from "../requests/ProposalsRequest.js";
import { FileRequest } from "../requests/FileRequest";
import { makeAutoObservable } from "mobx";
import { PROPOSAL_TYPES } from "../utils/constants.js";
class ProposalStore {
  proposalList = [];
  //lưu list biểu mẫu
  items = [];
  content = null;
  isLoadingForm = false;
  //
  proposalLeaveDetail = {};
  totalCountProposal = 0;
  pageIndex = 0;
  pageSize = 10;
  keyword = undefined;
  proposal_status = undefined;
  type = undefined;
  proposalPermission = undefined;
  proposalLeaveCommentList = [];
  vehicleList = [];
  totalCountVehicle = 0;
  otherDetail = {};
  otherCommentList = [];
  vehicleDetail = {};
  vehicleCommentList = [];
  formProposalType = null;
  activeTabProposal = "";

  proposalApproveConfig = {
    approvalCode: null,
    approvalLevels: [],
  };

  defaultQueryParams = {
    page: 0,
    size: 10,
    keyword: undefined,
    proposal_status: undefined,
    type: undefined,
    proposal_permission: undefined,
  };
  constructor() {
    makeAutoObservable(this);
  }

  formInputTemplate = null;

  defaultApprovalConfigUpdate = {
    approvalCode: null,
    approvalLevels: [],
  };

  setQueryParams = (payload) => {
    this.defaultQueryParams = payload;
  };

  clearOtherDetail = () => {
    this.otherDetail = {};
  };
  clearOtherCommentList = () => {
    this.otherCommentList = [];
  };

  setActiveTabProposal = (value) => {
    this.activeTabProposal = value;
  };

  setFilter = (filterName, filterValue) => {
    if (typeof filterName !== "string") return;
    this[filterName] = filterValue;
  };

  clearFilterProposal = () => {
    this.pageIndex = 0;
    this.pageSize = 10;
    this.keyword = undefined;
    this.proposal_status = undefined;
    this.type = undefined;
    this.proposalPermission = undefined;
  };
  // getProposals = params => {
  //   console.log('params', params)
  //   return new Promise((resolve, reject) => {
  //     ProposalsRequest.getProposals(params)
  //       .then(response => {
  //         if (!response) {
  //           return resolve(null)
  //         }
  //         resolve(response.data)
  //         this.proposalList = [...this.proposalList, ...response.data.data]
  //         this.totalCountProposal = response.data.total_count
  //       })
  //       .catch(error => reject(error))
  //   })
  // }

  // load list biểu mẫu
  load = () => {
    this.items = Object.values(PROPOSAL_TYPES).map((item) => {
      return {
        key: item.key,
        label: item.label,
      };
    });
  };
  clear = () => {
    this.items = [];
    this.isLoadingForm = false;
    this.content = null;
  };

  getDetails = async (key) => {
    let response = await ProposalsRequest.getDetails(key);
    this.content = response.data.content ?? "";
  };
  //

  getProposals = (params) => {
    const self = this; // Lưu trữ ngữ cảnh 'this'

    return new Promise((resolve, reject) => {
      ProposalsRequest.getProposals(params)
        .then((response) => {
          if (!response) {
            return resolve(null);
          }
          resolve(response.data);
          this.proposalList = [...this.proposalList, ...response.data.data]; // Sử dụng self thay vì this
          this.totalCountProposal = response.data.total_count;
        })
        .catch((error) => reject(error));
    });
  };

  // Lấy danh sách các cấp duyệt
  getApprovalTemplateListV2 = () => {
    return new Promise((resolve, reject) => {
      ProposalsRequest.getApprovalTemplateList()
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  getApprovalLevelTemplateByATCode = (code) => {
    return new Promise((resolve, reject) => {
      ProposalsRequest.getApprovalLevelTemplateByATCode(code)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  deleteProposalItem = (code) => {
    return ProposalsRequest.deleteProposalItem(code);
  };

  updateProposal = (payload) => {
    return new Promise((resolve, reject) => {
      ProposalsRequest.updateProposal(payload)
        .then((response) => resolve(response.data))
        .catch((error) => reject(error));
    });
  };

  clearType = () => {
    this.type = undefined;
  };

  clearFormProposalType = () => {
    this.formProposalType = null;
  };

  setFormProposalType = (value) => {
    switch (value) {
      case "BUSINESS_TRIP":
        this.formProposalType = {
          title: "Đăng ký công tác",
          value: value,
        };
        break;
      case "LEAVE":
        this.formProposalType = {
          title: "Đăng ký nghỉ phép",
          value: value,
        };
        break;
      case "LEAVE_ANNUAL":
        this.formProposalType = {
          title: "Đăng ký nghỉ phép hằng năm",
          value: value,
        };
        break;
      case "LEAVE_NO_SALARY":
        this.formProposalType = {
          title: "Đăng ký nghỉ phép không lương",
          value: value,
        };
        break;
      case "EVALUATE_MEMBER":
        this.formProposalType = {
          title: "Đăng ký đánh giá cán bộ < Nhân viên >",
          value: value,
        };
        break;
      case "EVALUATE_LEADER":
        this.formProposalType = {
          title: "Đăng ký đánh giá cán bộ < Trưởng ban >",
          value: value,
        };
        break;
      case "TIMEKEEPER":
        this.formProposalType = {
          title: "Tổng hợp chấm công",
          value: value,
        };
        break;
      case "STATIONERY":
        this.formProposalType = {
          title: "Đăng ký văn phòng phẩm",
          value: value,
        };
        break;
      case "MEETING":
        this.formProposalType = {
          title: "Giấy mời họp",
          value: value,
        };
        break;
      case "VEHICLE":
        this.formProposalType = {
          title: "Xin xe",
          value: value,
        };
        break;
      default:
        this.formProposalType = null;
    }
  };

  resetFormProposalType = () => {
    this.formProposalType = null;
  };

  /** Nghỉ phép*/

  createProposalLeave = (proposalLeaveInfo) => {
    return new Promise((resolve, reject) => {
      ProposalsRequest.createProposalLeave(proposalLeaveInfo)
        .then((response) => resolve(response.data))
        .catch((error) => reject(error));
    });
  };
  getProposalLeavesDetail = (proposalId) => {
    return new Promise((resolve, reject) => {
      ProposalsRequest.getProposalLeavesDetail(proposalId)
        .then((response) => {
          this.proposalLeaveDetail = response.data;
          resolve(response);
        })
        .catch((error) => reject(error));
    });
  };
  getProposalLeaveComment = (proposalId) => {
    return new Promise((resolve, reject) => {
      ProposalsRequest.getProposalLeaveComment(proposalId)
        .then((response) => {
          this.proposalLeaveCommentList = response.data;
          resolve(response);
        })
        .catch((error) => reject(error));
    });
  };
  createProposalLeaveComment = (proposalId, commentData) => {
    return new Promise((resolve, reject) => {
      ProposalsRequest.createProposalLeaveComment(proposalId, commentData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => reject(error));
    });
  };
  updateLeaveAssignPerson = (proposalId, data) => {
    return new Promise((resolve, reject) => {
      ProposalsRequest.updateLeaveAssignPerson(proposalId, data)
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  };

  /** Xe cộ */

  createVehicle = (vehicleInfo) => {
    return new Promise((resolve, reject) => {
      ProposalsRequest.createVehicle(vehicleInfo)
        .then((response) => resolve(response.data))
        .catch((error) => reject(error));
    });
  };
  getVehicleDetail = (proposalId) => {
    return new Promise((resolve, reject) => {
      ProposalsRequest.getVehicleDetail(proposalId)
        .then((response) => {
          this.vehicleDetail = response.data;
          resolve(response);
        })
        .catch((error) => reject(error));
    });
  };
  getVehicleComment = (proposalId) => {
    return new Promise((resolve, reject) => {
      ProposalsRequest.getVehicleComment(proposalId)
        .then((response) => {
          this.vehicleCommentList = response.data;
          resolve(response);
        })
        .catch((error) => reject(error));
    });
  };
  createVehicleComment = (proposalId, commentData) => {
    return new Promise((resolve, reject) => {
      ProposalsRequest.createVehicleComment(proposalId, commentData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => reject(error));
    });
  };
  updateVehicleAssignPerson = (proposalId, data) => {
    return new Promise((resolve, reject) => {
      ProposalsRequest.updateVehicleAssignPerson(proposalId, data)
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  };

  /** Khác */
  createOther = (otherInfo) => {
    return new Promise((resolve, reject) => {
      ProposalsRequest.createOther(otherInfo)
        .then((response) => resolve(response.data))
        .catch((error) => reject(error));
    });
  };
  getOtherDetail = (proposalId) => {
    return new Promise((resolve, reject) => {
      ProposalsRequest.getOtherDetail(proposalId)
        .then((response) => {
          this.otherDetail = response.data;
          resolve(response);
        })
        .catch((error) => reject(error));
    });
  };
  getOtherComment = (proposalId) => {
    return new Promise((resolve, reject) => {
      ProposalsRequest.getOtherComment(proposalId)
        .then((response) => {
          this.otherCommentList = response.data.reverse();
          resolve(response);
        })
        .catch((error) => reject(error));
    });
  };
  createOtherComment = (proposalId, commentData) => {
    return new Promise((resolve, reject) => {
      ProposalsRequest.createOtherComment(proposalId, commentData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => reject(error));
    });
  };
  updateOtherAssignPerson = (proposalId, data) => {
    return new Promise((resolve, reject) => {
      ProposalsRequest.updateOtherAssignPerson(proposalId, data)
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  };

  /** Tải file phiếu trình */

  downloadAttachment = (fileId) => {
    return new Promise((resolve, reject) => {
      FileRequest.downloadAttachment(fileId)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  deleteCommentProposal = (proposal_code, comment_id) => {
    return new Promise((resolve, reject) => {
      ProposalsRequest.deleteCommentProposal(proposal_code, comment_id)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => reject(error));
    });
  };

  deleteProposal = (proposalId) => {
    return new Promise((resolve, reject) => {
      ProposalsRequest.deleteProposal(proposalId)
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  };
  approvalProposalOther = (data) => {
    return new Promise((resolve, reject) => {
      ProposalsRequest.approvalProposalOther(data)
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  };

  getProposalTypeApprovalConfig = (proposalType) => {
    return new Promise((resolve, reject) => {
      ProposalsRequest.getProposalApprovalConfig(proposalType)
        .then((response) => {
          const approveConfig = {
            approvalCode: response.data.code,
            approvalLevels: response.data.approval_levels.map(
              (approvalLevel, index) => ({
                status: index === 0 ? "CREATED" : "WAITING",
                allow_edit: approvalLevel.allow_edit,
                code: approvalLevel.code,
                isDeleted: approvalLevel.is_deleted,
                level: approvalLevel.level,
                name: approvalLevel.name,
                username: approvalLevel.username,
              })
            ),
          };
          this.proposalApproveConfig = approveConfig;
          this.defaultApprovalConfigUpdate = approveConfig;
          this.formInputTemplate = response.data?.content_template;

          resolve(response);
        })
        .catch((error) => {
          const approveConfig = {
            approvalCode: null,
            approvalLevels: [],
          };
          this.proposalApproveConfig = approveConfig;
          this.defaultApprovalConfigUpdate = approveConfig;
          this.formInputTemplate = null;
          reject(error);
        });
    });
  };

  setDefaultApprovalConfigUpdate = (payload) => {
    this.defaultApprovalConfigUpdate = {
      ...this.defaultApprovalConfigUpdate,
      approvalLevels: payload,
    };
  };

  approveProposal = (proposalCode, payload) => {
    return new Promise((resolve, reject) => {
      ProposalsRequest.approveProposal(proposalCode, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  clearProposalList = () => {
    this.proposalList.length = 0;
    this.totalCountProposal = 0;
  };

  clearProposalStore = () => {
    this.proposalList.length = 0;
    this.totalCountProposal = 0;
    this.defaultQueryParams = {
      page: 0,
      size: 10,
      keyword: undefined,
      proposal_status: undefined,
      type: undefined,
      proposal_permission: undefined,
    };
  };
}

const proposalStore = new ProposalStore();
export default proposalStore;
